import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import './styles.scss';

interface IProps {
    value: string;
    readonly?: boolean;
    disabled?: boolean;

    change?: (value: string) => void;
}

const RichText = ({ value, readonly = false, disabled = false, change }: IProps) => {

    const config = readonly ? {
        toolbar: [],
        heading: {
            options: []
        },
        readOnly: true
    } : {
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
        heading: {
            options: [
                { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
            ]
        }
    }

    return (
        <div
            className={readonly ? 'readonly' : ''}>
            <CKEditor
                editor={ClassicEditor}
                config={config}
                disabled={disabled}
                data={value}
                onReady={() => { }}
                onChange={(event: any, editor: any) => {
                    const data = editor.getData();
                    if (change !== undefined)
                        change(data);
                }}
            />
        </div>

    );
};

export default RichText;